module.exports = __webpack_public_path__ + "static/media/FONDO_POP_UP.f09027a9.png";